import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Row } from "reactstrap";
import { IContentTitles } from "../app/models/content";
import { RootStoreContext } from "../app/stores/rootStore";
import GenericBrowsePageResizeHelper from "../components/common/GenericBrowsePageResizeHelper";
import Loader from "../components/common/Loader";
import GenericTeletabberGallery from "../components/gallery/GenericTeletabberGallery";
import TitleNavbar from "../components/navbars/TitleNavbar";
import ToolbarSelector from "../components/navbars/ToolbarSelector";

interface IParams {
  meetingId: string;
  nodeId: string;
}

const MeetingBrowsePage: React.FC<RouteComponentProps<IParams>> = ({
  match,
  location,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { currentBrowsePageContent, selectedLanguageId, resetBrowsePage } =
    rootStore.commonStore;
  const { attendingMeeting, canViewSurveys } = rootStore.playerStore;
  const { errorUrl } = rootStore.tenantStore;
  const { setSourceId, loadContent } = rootStore.meetingStore;
  const { destroyZwibblerContext } = rootStore.zwibblerStore;
  const { setSurveyParameters, resetSurveyParameters } = rootStore.surveyStore;
  const [nodeId, setNodeId] = useState(0);
  const [meetingId, setMeetingId] = useState(0);
  const [galleryStartingPage, setGalleryStartingPage] = useState(0);

  useEffect(() => {
    let intNodeId = parseInt(match.params.nodeId);
    let intMeetingId = parseInt(match.params.meetingId);

    if (intNodeId && intMeetingId) {
      setNodeId(intNodeId);
      setMeetingId(intMeetingId);
      setSourceId(intMeetingId);

      const urlParams = new URLSearchParams(location.search);
      //gallery page
      const page = urlParams.get("pag") ?? "";
      let intPage = parseInt(page);
      setGalleryStartingPage(intPage);
      //meeting language
      const lang = urlParams.get("lang") ?? "";
      let documentLanguage = lang ? parseInt(lang) : selectedLanguageId;
      if (canViewSurveys) setSurveyParameters(intMeetingId, intNodeId);
      loadContent(intNodeId, documentLanguage)
        .then()
        .catch(() => history.push(errorUrl));
    } else history.push(errorUrl);

    return () => {
      resetSurveyParameters();
      resetBrowsePage();
      destroyZwibblerContext();
    };
  }, [
    location.search,
    match.params.meetingId,
    match.params.nodeId,
    errorUrl,
    history,
    loadContent,
    // canViewSurveys, //fix bug NTMD-361
    selectedLanguageId,
    setSourceId,
    setGalleryStartingPage,
    resetBrowsePage,
    setSurveyParameters,
    resetSurveyParameters,
    destroyZwibblerContext,
  ]);

  const getPageTitle = (contentTitle: IContentTitles) => {
    let meetingInfo = ``;
    if (attendingMeeting && attendingMeeting.title === contentTitle.source)
      meetingInfo = ``;
    else meetingInfo = `(${contentTitle.source})`;
    return `${contentTitle.document} ${meetingInfo}`;
  };

  if (!currentBrowsePageContent) return <Loader />;

  return (
    <>
      <GenericBrowsePageResizeHelper />
      <Row>
        <TitleNavbar title={getPageTitle(currentBrowsePageContent.title)} />
      </Row>
      <Row>
        <ToolbarSelector
          items={currentBrowsePageContent.items}
          isSidebarOpen={true}
          languageSelectionConfig={{
            changeLanguage: (l) =>
              loadContent(nodeId, l).then(
                (res) => res.contentData.convertedPagesNumber
              ),
          }}
          contentConfig={{
            contentId: currentBrowsePageContent.contentId!,
            downloadConfig: {
              source: "meetings",
              sourceId: meetingId,
            },
            enableNotes: true,
          }}
          stickyButton="share"
        />
      </Row>
      <Row>
        <GenericTeletabberGallery
          items={currentBrowsePageContent.items}
          startingPage={galleryStartingPage}
        />
      </Row>
    </>
  );
};

export default observer(MeetingBrowsePage);
